export enum LoadType {
  SCRIPT = "SCRIPT",
  GTM = "GTM"
}

export enum CookieManager {
  IN_HOUSE = "IN_HOUSE",
  ONE_TRUST = "ONE_TRUST",
  UNKNOWN = "UNKNOWN",

  ALLOW_ALL = "ALLOW_ALL"
}

export enum CookieConsentType {
  ANALYTICAL = "ANALYTICAL",
  FUNCTIONAL = "FUNCTIONAL",
  MARKETING = "MARKETING"
}
